/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import { formatOptions } from 'Shared/helpers/chart';

const ReactChartJs = loadable.lib(() => import('react-chartjs-2'));

class BarChart extends Component {
  render() {
    const { height, datasets, labels, options } = this.props;
    const data = { datasets, labels };

    if (!options) {
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
          },
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: { fontSize: 10 },
        },
        scales: {
          xAxes: [
            {
              gridLines: { display: false },
            },
          ],
          yAxes: [
            {
              gridLines: { display: true },
            },
          ],
        },
      };
    }

    return (
      <ReactChartJs>
        {({ Bar, Chart }) => <Bar data={data} options={formatOptions(options, Chart)} height={height} />}
      </ReactChartJs>
    );
  }
}

BarChart.propTypes = {
  height: PropTypes.number,
  datasets: PropTypes.array,
  labels: PropTypes.array,
  options: PropTypes.object,
};

export default connect()(BarChart);
